import {color_note} from "../Fonctions"

export function Stats_eleve ({user}) {

  	return (
    <div className="content max">
    	<h1>Statistiques sur mes résultats </h1>

        {!user.moyenne ? 
        <>
            Retrouver, ici, des statistiques sur vos résultats.<br/><br/>
            <div className="alert info ">
                <br/>Vous n'avez pas de statistiques Automaths pour le moment.<br/><br/>
            </div>
        </> :  
        <>
    	<div className="card">
            <h1>Ma moyenne</h1>
            <h2>Générale<span className="fadeout5">*</span></h2>
            <span className={'card_note '+color_note(user.moyenne)}>{user.moyenne}%</span>
            <br/>
            
            {user.nb_zero && <>
            		<span className="zero" title={'Zéro obtenu sur : \u000d'+user.nb_zero_activ.replaceAll('&#10;', '\u000d')}>{user.nb_zero}</span>
            		<div className="contains alert">
                     	Vous avez obtenu {user.nb_zero} zéro{user.nb_zero>1 ? 's':''}.
                  	</div>
                  	</>
            }
            <span className="alert"></span>
			<div title="Moyenne générale de la classe" style={{color:"grey", align:"left"}}>Moyenne classe : {user.moy_activite_all_classe}%</div>
        </div>

      	<div className="card">
	        <h1>Ma note min</h1>
	        <span className={'card_note '+color_note(user.moyenne_min)}>{user.moyenne_min}%</span>
	        <br/>
	        <div className="contains" dangerouslySetInnerHTML={{ __html:user.moyenne_min_aff}}></div>
       	</div>

       	<div className="card">
            <h1>Ma note max</h1>
            <span className={'card_note '+color_note(user.moyenne_max)}>{user.moyenne_max}%</span>
            <br/>
	        <div className="contains" dangerouslySetInnerHTML={{ __html:user.moyenne_max_aff}}></div>
        </div>
        </>
        }
    </div>
  	);
}